import {Component, OnInit, OnDestroy, HostListener, EventEmitter, ViewChild} from '@angular/core';
import {interval} from "rxjs";

import {Subscription} from "rxjs";

import {Location} from '@angular/common';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import * as Communication from '../communication/index';
import {Config} from '../../environments/environment';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {ToolbarEventPageEnum} from "../shared/common/ToolbarEvent";
import {ToolbarEvent} from "../shared/common/ToolbarEvent";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {DomSanitizer} from "@angular/platform-browser";
import {Observable} from "rxjs";
import { HttpHeaders, HttpParams, HttpResponse, HttpClient } from '@angular/common/http';

// Shared signing services
import { HwcryptoService, HwcryptoCertificate } from '../shared/services/hwcrypto.service';
import { MobileSigningService } from '../shared/services/mobile-signing.service';
import { SigningStatusService, SigningStatus, StatusPollResult } from '../shared/services/signing-status.service';
import { DigitalSignerModalComponent, SigningResult } from '../shared/components/digital-signer-modal/digital-signer-modal.component';

declare var $: any;
declare var swal: any;
declare var hwcrypto: any;

/**
 * This class represents the lazy loaded SigningCadesComponent.
 */
@Component({
    selector: 'sd-signing-cades',
    templateUrl: 'signing-cades.component.html',
    styleUrls: ['signing-cades.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.FieldsService, Communication.RecipientRequestService, Communication.RecipientsService],
    standalone: false
})
export class SigningCadesComponent implements OnInit, OnDestroy {

  @ViewChild('digitalSignerModal') digitalSignerModal: DigitalSignerModalComponent;

  model: {
    operator: string;
    mobile: string;
  };

  kiCitizenId: string = "";
  isSignDocumentClicked: boolean = false;
  isSignDocumentClickedMobile: boolean = false;
  showChooseCertificateText: boolean = false;
  afterPinTextEntered: boolean = false;
  signingTerminated = false;

  jobIDParameter: number;
  requestCode: string;
  signStatus: string;
  onModalCancel: boolean = false;  //imzalama cancel tuşuna basınca aktif olcak

  theJob: Communication.Job;
  theRecipient: Communication.Recipient;
  signingReason: string = "";
  signingLocation: string = "";

  isMobilSignSecondPage: boolean = false; //modalda imzala düğmesine tıklandığında ikinci sayfaya geçiş
  closePage: boolean = false; //modal cancel düğmesine tıklandığında ya da en son imzalama ile ilgili bildirimler sonrası
  showPromptDialog: boolean = false; //prompt dialoğu göstermek için

  returnUrl: string;
  theDocument: Communication.Document;

  isMobilSignClicked: boolean = false;
  mobilSignModel = {
    mobile: "",
    operator: ""
  };
  operators = [
    {value: 'turkcell', display: 'Turkcell'},
    {value: 'telekom', display: 'Turk Telekom'},
    {value: 'vodafone', display: 'Vodafone'}
  ];
  fingerPrint: string = "";

  hwcryptoModel: any = {
    hashtype: 'SHA-256',
    backend: 'chrome',
    language: 'tr',
    filter: 'SIGN',
    certificate: ''
  };

  timerSubscription: Subscription;
  subscriptions: Subscription[] = [];
  currentToolbar: any;
  isRequestCodeUsed: boolean = false;
  signReturnURL: string = null; //the url to return after signing


  recipientColors = ["#A9BCF5", "#BCF5A9", "#F3E2A9", "#F5A9A9", "#E6E6E6", "#A9F5F2", "#FE642E", "#F2F2F2", "#DBA901", "#AEDEF0", "#FDEFC6", "#ECB7CE", "#FDF4ED", "#F6DDC8", "#EDBC92", "#FFEDBB", "#F2E0E7", "#F2E0E7", "#5CB5DB", "#F6DACA", "#F69F99", "#9D8FB8"];

  accordionDisplayIdSubject = new BehaviorSubject("");
  zoomSubject = new BehaviorSubject("1.0");
  refreshCanvasSubject = new BehaviorSubject("true");
  rotationSubject = new BehaviorSubject("0");
  resizeTimer: any;
  radioUpdateTimer: any;

  docFields: any = [];
  shapeId: number = 1;
  fonts = ['Arial', 'Times New Roman'];
  sizes: any = [10, 12, 14, 16, 24, 36];

  fillAlertShapes: any = [];
  previousWidth: number;
  changesSaved: boolean = false;

  originalSize: boolean = true;
  showAll: boolean = true;
  renderText: boolean = false;

  pdfSrc: any = {
    'url': '',
    'httpHeaders': {
      'access_token': "1"
    }
  };

  selectedField: any;
  scaledImage: any;
  uploadError: string = "";
  lastShapePage: number;
  stopResizeEvent: boolean = false;
  websiteAddress: string;

  stylesInput: string = "";
  stylesFonts: Array<String> = ['Cititype Michigan Sign'];
  stylesFontIndex: number = 0;


  constructor(
    private jobsApi: Communication.JobsService,
    private fieldsApi: Communication.FieldsService,
    private documentsApi: Communication.DocumentsService,
    private recipientRequestApi: Communication.RecipientRequestService,
    private activatedRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private toolbarService: ToolbarService,
    private authorization: Authorization,
    private navigationService: NavigationService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private domSanitizer: DomSanitizer,
    private recipientsApi: Communication.RecipientsService,
    private http: HttpClient,
    // Shared signing services
    private hwcryptoService: HwcryptoService,
    private mobileSigningService: MobileSigningService,
    private signingStatusService: SigningStatusService
  ) {






    this.websiteAddress = Config.WEBSITE;
    this.afterLoadComplete = this.afterLoadComplete.bind(this);
  }

  afterLoadComplete() {

  }


  onError($event: any) {
    //console.error($event)
    //this.notificationService.documentNotFound();
  }


  ngOnInit() {
    console.log("isAuthenticated " + this.authorization.isInitializedAfterLogin());

    this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
      (event: NavigationEvent) => this.onNavigationEvent(event)
    ));

    this.subscriptions.push(this.toolbarService.eventOccured$.subscribe(
      (event: ToolbarEvent) => this.onToolbarEvent(event) //get the page info
    ));

    this.subscriptions.push(this.activatedRoute.params.subscribe(
      (param) => {
        this.requestCode = param['code'];
        console.log("sign - requestCode: " + this.requestCode);

        if (param['code'] == null) {
          //TODO:ERROR
          alert("Access Denied");
        }

        this.GetTheJobWithRequestCode();
        this.RoutingBack();

      })
    );

    this.InitMobilFormData();
  }

  private onToolbarEvent(event: ToolbarEvent) {
    this.isRequestCodeUsed = false;
    this.currentToolbar = event;

    if (this.currentToolbar.recipientState == 'SIGNED' || this.currentToolbar.recipientState == 'DECLINED') {
      this.isRequestCodeUsed = true;
    }
  }

  isMobile() {
    return /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && screen.width <= 500
  }

  @HostListener('window:resize', ['$event'])
  onResize($event: any) {
  }

  GetTheJobWithRequestCode() {
    console.log("GetTheJobWithRequestCode()");

    this.subscriptions.push(this.recipientRequestApi.recipientRequestsCodeJobGet(this.requestCode).subscribe(
      (response: Communication.JobOfCode) => {

        this.theJob = response.job;
        this.theRecipient = response.recipient;
        this.jobIDParameter = this.theJob.id;
        this.signReturnURL = response.url;
        this.theDocument = this.theJob.documents[0];

        // console.log("response:" +response);
        // console.log("jobIDParameter:" + this.jobIDParameter);
        // console.log("job status " + this.theJob.status);
        // console.log("job type " + this.theJob.type);
        // console.log("document url " + this.pdfSrc.url);
        // console.log("this.theJob.documents[0].id " + this.theJob.documents[0].id);
        // console.log("Recipient " + response.recipient.email + "  isRegistered : " + response.recipient.isRegistered);

        let accessToken = this.authorization.getAccessToken();
        let authorized = false;

        //alert if document already rejected
        let byWhom: string = this.isRequestCodeUsed ? "you" : "others";
        if (this.theJob.status == "REJECTED")
          this.notificationService.documentAlreadyRejected(byWhom);

        let eventPageEnum: ToolbarEventPageEnum = ToolbarEventPageEnum.JOB_SIGN_REQUEST;
        if (this.theJob.type.toUpperCase() == "SELF") {
          eventPageEnum = ToolbarEventPageEnum.JOB_SELF_SIGNING;
          //$("#myModal").modal('show');
        }

        this.toolbarService.action(new ToolbarEvent(eventPageEnum, this.theJob.type, this.theJob.user.id, this.theRecipient.status, this.theJob.name, this.theJob.status, "", "", ""));

        //}

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        if (err.json().code == 222) {
          let _thisErr = this;
          this.notificationService.showRequestCodeAlreadyUsed(err.json().description, function (isConfirmed: boolean) {
            if (isConfirmed) {
              //_thisErr.router.navigate(['/doc', _thisErr.theJob.id]);
            }
          });
        } else {
          this.notificationService.displayError(err);
        }
      }
    ));

  }



  public RoutingBack() {
    this.returnUrl = this.route.snapshot.queryParams['url'] || '';
  }

  /**
   * Initiate USB e-ID signing using HwcryptoService
   */
  public openEidSign(): void {
    if (this.signingTerminated) {
      return;
    }

    this.isSignDocumentClicked = true;

    // Step 1: Get certificate from smart card using HwcryptoService
    this.isSignDocumentClicked = false;
    this.showChooseCertificateText = true;

    this.subscriptions.push(
      this.hwcryptoService.getCertificate().subscribe({
        next: (certificate: HwcryptoCertificate) => {
          if (this.signingTerminated) {
            console.log("Signing cancelled by user");
            this.resetUsbSigningState();
            return;
          }

          console.log("certificate received...");
          this.hwcryptoModel.certificate = certificate;
          this.showChooseCertificateText = false;
          this.isSignDocumentClicked = true;

          // Step 2: Get token hash from server
          this.getTokenHashAndSign(certificate);
        },
        error: (error: any) => {
          console.error("Certificate error:", error?.message || error);
          this.notificationService.OpenEIdSigningError(error?.message || 'Certificate selection failed');
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Get token hash from server and sign it
   */
  private getTokenHashAndSign(certificate: HwcryptoCertificate): void {
    this.subscriptions.push(
      this.recipientRequestApi.recipientRequestsCodeTokenhashPut(
        this.requestCode,
        certificate.hex,
        this.signingReason,
        this.signingLocation
      ).subscribe({
        next: (response: any) => {
          console.log("token hash received...");
          const hash = response.resources?.[0]?.source || response.source;
          this.signWithHwcrypto(hash);
        },
        error: (err: any) => {
          console.error("Token hash error:", err);
          this.notificationService.displayError(err);
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Convert base64 to hex (delegated to HwcryptoService)
   * @deprecated Use hwcryptoService.base64toHEX instead
   */
  base64toHEX(base64: string): string {
    return this.hwcryptoService.base64toHEX(base64);
  }

  /**
   * Sign the hash using HwcryptoService
   */
  signWithHwcrypto(hash: string): void {
    if (!this.hwcryptoModel.certificate) {
      this.notificationService.OpenEIdSigningError('No certificate selected');
      this.resetUsbSigningState();
      return;
    }

    this.subscriptions.push(
      this.hwcryptoService.sign(this.hwcryptoModel.certificate, hash).subscribe({
        next: (signature) => {
          console.log("signature received..");
          this.afterPinTextEntered = true;
          this.isSignDocumentClicked = false;

          // Step 3: Send signature to server
          this.sendSignatureToServer(signature.hex);
        },
        error: (error: any) => {
          console.error("Signing failed:", error?.message || error);
          this.notificationService.OpenEIdSigningError(error?.message || 'Signing failed');
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Send the signature to the server
   */
  private sendSignatureToServer(signatureHex: string): void {
    this.subscriptions.push(
      this.recipientRequestApi.recipientRequestsCodeTokensignaturePost(
        this.requestCode,
        signatureHex
      ).subscribe({
        next: (response: any) => {
          console.log("Signing successful...");
          this.handleUsbSigningSuccess();
        },
        error: (err: any) => {
          console.error("Signature submission error:", err);
          this.notificationService.displayError(err);
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Handle successful USB signing
   */
  private handleUsbSigningSuccess(): void {
    $("#myModal").modal('hide');

    // Handle navigation based on login state
    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobSigned(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          if (this.signReturnURL != null && this.signReturnURL != '') {
            // Redirect to given return URL
            window.location.href = `${this.signReturnURL}?jobId=${this.theJob.id}`;
          } else {
            this.router.navigate(['/doc', this.theJob.id]);
          }
        }
      });
    } else {
      this.notificationService.jobSigned(this.theJob.name);
      this.RedirectReferredPage();
    }

    // Log toolbar event
    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    if (this.theJob.type.toUpperCase() === "SELF") {
      this.notificationService.jobCompleted(this.theJob.name);
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "COMPLETED", this.theJob.location, "", ""
      ));
    } else {
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "", "", "", ""
      ));
    }
  }

  /**
   * Reset USB signing state
   */
  private resetUsbSigningState(): void {
    this.isSignDocumentClicked = false;
    this.afterPinTextEntered = false;
    this.showChooseCertificateText = false;
    this.hwcryptoModel.certificate = null;
  }


  /**
   * Initialize mobile sign form data
   */
  public InitMobilFormData(): void {
    this.mobilSignModel = this.mobileSigningService.createDefaultFormData();
  }

  /**
   * Initiate mobile signing using MobileSigningService
   * NOTE: This fixes the parameter order bug - previously had incorrect order:
   *   (operator, mobile, reason, location, code) - WRONG
   *   Now uses correct order via MobileSigningService:
   *   (code, operator, mobile, reason, location) - CORRECT
   */
  public mobileSign(formData: any): void {
    console.log(`${formData.operator} ${formData.mobileNumber}`);
    this.isSignDocumentClickedMobile = true;

    this.subscriptions.push(
      this.mobileSigningService.initiateMobileSign({
        requestCode: this.requestCode,  // FIXED: code is now first parameter
        operator: formData.operator,
        mobile: formData.mobileNumber,
        reason: this.signingReason,
        location: this.signingLocation
      }).subscribe({
        next: (result) => {
          console.log("fingerPrint " + result.fingerPrint);

          if (result.success && result.formattedFingerPrint) {
            this.isMobilSignSecondPage = true;
            this.isMobilSignClicked = false;
            this.fingerPrint = result.formattedFingerPrint;

            // Start polling for status using SigningStatusService
            this.startMobileSigningPolling();
          } else {
            this.notificationService.signingMobileSignNotFound();
            this.resetMobileSigningState();
          }
        },
        error: (err: any) => {
          console.error("Mobile sign error:", err);
          this.notificationService.displayError(err);
          this.resetMobileSigningState();
        }
      })
    );
  }

  /**
   * Start polling for mobile signing status using SigningStatusService
   */
  private startMobileSigningPolling(): void {
    this.subscriptions.push(
      this.signingStatusService.startPolling(this.requestCode).subscribe({
        next: (result: StatusPollResult) => {
          if (this.onModalCancel) {
            return; // Polling paused by user
          }
          this.handleMobileSigningStatus(result);
        },
        error: (err) => {
          console.error("Status polling error:", err);
          $("#myModal").modal('hide');
          this.notificationService.displayError(err);
        }
      })
    );
  }

  /**
   * Handle mobile signing status result
   */
  private handleMobileSigningStatus(result: StatusPollResult): void {
    console.log("Mobile Status:", result.status);

    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    if (result.isSuccess) {
      this.signingStatusService.stopPolling();
      this.handleMobileSigningSuccess(eventPageEnum);
    } else if (result.isRejected) {
      this.signingStatusService.stopPolling();
      this.handleMobileSigningRejected(eventPageEnum);
    } else if (result.status === SigningStatus.CERTIFICATE_EXPIRING_SOON) {
      this.signingStatusService.stopPolling();
      this.notificationService.certificateExpiringSoon();
      this.mobilSignErrororCancel("");
    } else if (result.isError) {
      this.signingStatusService.stopPolling();
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "WAITING", this.theJob.name, this.theJob.status, "", "", ""
      ));
      this.notificationService.signingError(this.theJob.name, result.status);
      this.mobilSignErrororCancel("");
    } else if (result.status === 'TIMEOUT') {
      this.mobilSignErrororCancel("timeout");
    }
    // WAITING status - continue polling (handled by service)
  }

  /**
   * Handle successful mobile signing
   */
  private handleMobileSigningSuccess(eventPageEnum: ToolbarEventPageEnum): void {
    $("#myModal").modal('hide');

    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobSigned(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          if (this.signReturnURL) {
            window.location.href = `${this.signReturnURL}?jobId=${this.theJob.id}`;
          } else {
            this.router.navigate(['/doc', this.theJob.id]);
          }
        }
      });
    } else {
      this.notificationService.jobSigned(this.theJob.name);
      this.RedirectReferredPage();
    }

    if (this.theJob.type.toUpperCase() === "SELF") {
      this.notificationService.jobCompleted(this.theJob.name);
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "COMPLETED", this.theJob.location, "", ""
      ));
    } else {
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "", "", "", ""
      ));
    }
  }

  /**
   * Handle rejected mobile signing
   */
  private handleMobileSigningRejected(eventPageEnum: ToolbarEventPageEnum): void {
    $("#myModal").modal('hide');

    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobRejected(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobRejected(this.theJob.name);
      this.RedirectReferredPage();
    }

    this.toolbarService.action(new ToolbarEvent(
      eventPageEnum, this.theJob.type, this.theJob.user.id,
      "DECLINED", this.theJob.name, "REJECTED", "", "", ""
    ));
  }

  /**
   * Handle mobile sign error or cancel
   */
  mobilSignErrororCancel(source: string): void {
    this.signingStatusService.stopPolling();

    // Also stop legacy timer if it exists
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }

    if (source === "timeout") {
      this.notificationService.signingTimeout(this.theJob.name);
    }

    this.resetMobileSigningState();
  }

  /**
   * Reset mobile signing state
   */
  private resetMobileSigningState(): void {
    this.isMobilSignSecondPage = false;
    this.isSignDocumentClickedMobile = false;
    this.isMobilSignClicked = false;
    this.InitMobilFormData();
  }

  /**
   * Poll for signing status (legacy method, now uses SigningStatusService internally)
   * @deprecated Use startMobileSigningPolling instead
   */
  public RecipientRequestsCodeStatus(source: string): void {
    // This method is kept for backward compatibility
    // The new implementation uses SigningStatusService.startPolling()
    this.subscriptions.push(
      this.signingStatusService.checkStatus(this.requestCode).subscribe({
        next: (result: StatusPollResult) => {
          this.handleMobileSigningStatus(result);
        },
        error: (err) => {
          console.error("Status check error:", err);
          this.signingStatusService.stopPolling();
          $("#myModal").modal('hide');
          this.notificationService.displayError(err);
        }
      })
    );
  }

  goBack() {
    let self = this;
    let activeTab = $('ul#tabs li.active').text().trim();

    if (this.translate.instant(activeTab) == this.translate.instant("Mobile Sign")) {
      //turn first page and reset form
      if (this.isMobilSignSecondPage) {
        this.mobilSignErrororCancel("user cancelled");
      } else {
        cancelSign();
      }
    }

    if (this.translate.instant(activeTab) == this.translate.instant("USB E-Signature")) {
      cancelSign();
    }


    function cancelSign() {
      self.signingTerminated = true;
      self.notificationService.showJobSigningCancelAlert(function (isConfirmed: boolean) {
        if (isConfirmed) {
          self.SigningCalcel(isConfirmed);
          self.notificationService.jobCanceled(self.theJob.name);
        }
      });
    }

  }

  SigningCalcel(isConfirmed: boolean) {
    if (isConfirmed) {
      $("#myModal").modal('hide');
      this.RedirectReferredPage();
    }
  }

  public RedirectReferredPage() {

    //console.log("Redirect Referred Page");
    //console.log("this.previousUrl")
    //if(this.returnUrl != ''){
    //  window.location.href = this.returnUrl;
    //console.log("this.returnUrl != '' this.returnUrl "+this.returnUrl);
    //}else{
    //this.location.back(); // çağıran sayfaya dönmek için
    let _thisRedirect = this;
    if (this.authorization.authenticated()) {
      setTimeout(function () {
        _thisRedirect.router.navigate(['/doc', _thisRedirect.theJob.id]);
      }, 2000);
    } else {
      setTimeout(function () {
        _thisRedirect.location.back();
      }, 2000);
    }
    //}
  }


  private onNavigationEvent(event: NavigationEvent) {
    switch (event.acton) {
      case "REJECT_SIGN":
        this.RejectSign();
        break;
      case "APPROVE_SIGN": {
        this.ApproveSign();
        break;
      }
    }
  }

  RejectSign() {
    let _thisReject = this;
    this.notificationService.showJobSigningRejectAlert(function (isConfirmed: boolean) {
      if (isConfirmed) {
        _thisReject.subscriptions.push(_thisReject.recipientRequestApi.recipientRequestsCodeRejectPost(_thisReject.requestCode).subscribe(
          (response: any) => {
            console.log("rejected...: " + response.code);
            if (response.code == 200) {
              _thisReject.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.JOB_SIGN_REQUEST, _thisReject.theJob.type, _thisReject.theJob.user.id, "DECLINED", _thisReject.theJob.name, "REJECTED", "", "", ""));

              //without login
              if (!_thisReject.authorization.isInitializedAfterLogin()) {
                _thisReject.notificationService.showJobRejected(_thisReject.theRecipient.isRegistered, function (isConfirmed: boolean) {
                  if (isConfirmed) {
                    _thisReject.router.navigate(['/doc', _thisReject.theJob.id])
                  }
                });
                //with login
              } else {
                _thisReject.notificationService.jobRejected(_thisReject.theJob.name);
                _thisReject.router.navigate(['/doc', _thisReject.theJob.id]);
              }
            }

          }, //Bind to view
          (err: any) => {
            // Log errors if any
            console.log(err);
            _thisReject.notificationService.displayError(err);
          }
        ));

      }
    });
  }

  ApproveSign() {
    let self = this;
    //alert if document already rejected
    if (self.theJob.status == "REJECTED") {
      let byWhom: string = self.isRequestCodeUsed ? "you" : "others";
      self.notificationService.documentAlreadyRejected(byWhom);
    } else {
      // Show shared digital signer modal
      if (self.digitalSignerModal) {
        self.digitalSignerModal.showModal();
      } else {
        // Fallback to jQuery for backwards compatibility
        $("#myModal").modal('show');
      }
    }
  }


  isEmpty(str: string) {
    return (!str || 0 === str.length);
  }

  //color code to rgba for transparent convertion
  hexToRGBA(hex: any, opacity: any) {
    if (opacity == "1.0")
      return hex;

    return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l: any) {
      return parseInt(hex.length % 2 ? l + l : l, 16)
    }).concat(opacity || 1).join(',') + ')';
  }

  base64MimeType(base64Image: string): any {
    let result: any = null;

    if (this.isEmpty(base64Image)) {
      return result;
    }

    let mime: any = base64Image.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

    if (mime && mime.length) {
      result = mime[1];
    }

    return result;
  }


  ngOnDestroy() {
    //remove zebra html content
    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    this.subscriptions.forEach(
      (s: Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }


  /**
   *
   * Custom http for Download given document
   * @param accessToken System access token
   * @param id id of the document
   */
  // Update recipientRequestDownloadGet:
  /*
  private recipientRequestDownloadGet(code: string, pass: string, extraHttpRequestParams?: any): Observable<any> {
    const path = this.documentsApi.basePath + '/recipient_requests/{code}/download'
      .replace('{' + 'code' + '}', code);

    // Set headers if needed
    const headers = new HttpHeaders(this.documentsApi.defaultHeaders);

    // Use HttpClient.get with responseType 'arraybuffer'
    return this.http.get(path, {
      headers: headers,
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

   */


  //TODO: Update recipientRequestCodeDownloadGet:
  downloadFile() {
    this.notificationService.documentDownloadStarted(this.theJob.name);

    this.subscriptions.push(this.recipientRequestApi.recipientRequestsCodeDownloadGet(this.requestCode, "").subscribe(
      (data: any) => {
        const contentType = data.headers.get('Content-Type') || 'application/pdf';
        const blob = new Blob([data.body], { type: contentType });

        const url = window.URL.createObjectURL(blob);
        const linkElement = document.createElement('a');
        linkElement.setAttribute('href', url);
        linkElement.setAttribute('download', this.theJob.name);

        linkElement.click();
      },
      (err: any) => {
        console.log(err);
        this.notificationService.documentNotFound();
      }
    ));
  }

  // ============================================
  // Shared Digital Signer Modal Event Handlers
  // ============================================

  /**
   * Handle successful signing from shared digital signer modal
   */
  onSignComplete(result: SigningResult): void {
    console.log('Sign complete:', result);

    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    // Log toolbar event
    if (this.theJob.type.toUpperCase() === "SELF") {
      this.notificationService.jobCompleted(this.theJob.name);
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "COMPLETED", this.theJob.location, "", ""
      ));
    } else {
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "", "", "", ""
      ));
    }

    // Handle navigation based on login state and signReturnURL
    if (!this.authorization.isInitializedAfterLogin()) {
      // Check for signReturnURL redirect (CAdES specific)
      if (this.signReturnURL) {
        window.location.href = `${this.signReturnURL}?jobId=${this.theJob.id}`;
      } else {
        this.notificationService.showJobSigned(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
          if (isConfirmed) {
            this.router.navigate(['/doc', this.theJob.id]);
          }
        });
      }
    } else {
      this.notificationService.jobSigned(this.theJob.name);
      this.RedirectReferredPage();
    }
  }

  /**
   * Handle cancellation from shared digital signer modal
   */
  onSignCancelled(): void {
    console.log('Sign cancelled');
    this.signingTerminated = true;
    this.signingStatusService.stopPolling();

    // Reset state flags
    this.isSignDocumentClicked = false;
    this.afterPinTextEntered = false;
    this.showChooseCertificateText = false;
    this.isMobilSignSecondPage = false;
    this.isSignDocumentClickedMobile = false;
    this.isMobilSignClicked = false;
  }

  /**
   * Handle rejection from shared digital signer modal
   */
  onSignRejected(): void {
    console.log('Sign rejected');

    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    this.toolbarService.action(new ToolbarEvent(
      eventPageEnum, this.theJob.type, this.theJob.user.id,
      "DECLINED", this.theJob.name, "REJECTED", "", "", ""
    ));

    // Handle navigation based on login state
    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobRejected(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobRejected(this.theJob.name);
      this.RedirectReferredPage();
    }
  }
}

class Container {
  constructor(public page: string, public canvas: any, public bgPanel: any) {
  }
}
